import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_NORTE_TANGER_FEZ } from "@/lib/itineraryHubs";

export default function NorteTangerFezHubPage() {
  return <ItineraryHubPage hub={HUB_NORTE_TANGER_FEZ} />;
}
